//import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { AppBar,IconButton, Toolbar } from '@mui/material';

// project import
//import AppBarStyled from './AppBarStyled';
import HeaderContent from './HeaderContent';
import { useMediaQuery } from '@mui/material';
// assets
import { CaretLeftOutlined } from '@ant-design/icons';
import { backgroundColor } from 'utils/constants';
import { useLocation } from 'react-router-dom';
import React from 'react';
import { fetchHeaderAnnouncement } from 'Service/ApiService';

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

const Header = ({ open, setOpen, sidebarWidth, hideOnPendingOrder, hidebackIcon, handleDrawerToggle }) => {
  const theme = useTheme();
  const isMobileSidebar = useMediaQuery('(max-width:900px)');
  const HEADER_HEIGHT = 72;
  const MARQUEE_HEIGHT = 28;
  const location = useLocation();
  const currentPath = location.pathname;
  const iconBackColor = 'grey.100';
  const [marqueeText, setMarqueeText] = React.useState('');
  //const iconBackColorOpen = 'grey.200';
  const customer = JSON.parse(localStorage.getItem('headerCustomer') || 'null');
  const distibutor = JSON.parse(localStorage.getItem('distributorName') || 'null');
  const confvalue = (() => {
    try {
      return JSON.parse(localStorage.getItem('confvalue') || 'null') || {};
    } catch (error) {
      return {};
    }
  })();
  const user = JSON.parse(localStorage.getItem('user') || 'null');
  const orderNumberString = localStorage.getItem('showordernumber');
  const secondaryOrder = JSON.parse(localStorage.getItem('SecondarySalesOrderDraft') || 'null');
  const showSecondaryOrderDetails = [
    '/secondary-sales-order/barcode-dashboard',
    '/secondary-sales-order/barcode-scan',
    '/secondary-sales-order/barcode-entry',
    '/secondary-sales-order/products'
  ].includes(currentPath);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const hasAnnouncement = Boolean(marqueeText.trim());

  React.useEffect(() => {
    let isMounted = true;

    const loadAnnouncement = async () => {
      try {
        const response = await fetchHeaderAnnouncement();
        const nextText = response?.success && response?.data?.announcement ? response.data.announcement.trim() : '';

        if (isMounted) {
          setMarqueeText(nextText);
        }
      } catch (error) {
        if (isMounted) {
          setMarqueeText('');
        }
      }
    };

    loadAnnouncement();

    return () => {
      isMounted = false;
    };
  }, []);

  React.useEffect(() => {
    const topOffset = `${HEADER_HEIGHT + (hasAnnouncement ? MARQUEE_HEIGHT : 0)}px`;
    document.documentElement.style.setProperty('--main-layout-top-offset', topOffset);

    return () => {
      document.documentElement.style.setProperty('--main-layout-top-offset', `${HEADER_HEIGHT}px`);
    };
  }, [hasAnnouncement]);
  // console.log("orderNumberString",orderNumberString);
  // common header
  const mainHeader = (
    <Toolbar
      className={'header-MuiToolbar-root'}
      sx={{
        minHeight: { xs: HEADER_HEIGHT, sm: HEADER_HEIGHT },
        height: HEADER_HEIGHT,
        px: { xs: 1, sm: 2 },
        py: 0,
        display: 'flex',
        alignItems: 'center'
      }}
    >
      {hideOnPendingOrder ? (
        <IconButton
          disableRipple
          aria-label="open drawer"
          onClick={handleDrawerToggle}
          edge="start"
          color="secondary"
          sx={{ color: 'text.primary', bgcolor: iconBackColor, ml: { xs: 0, lg: -2 } }}
        >
          {<CaretLeftOutlined />}
        </IconButton>
      ) : (
        <span />
      )}
{/* <span></span> */}
      <div style={{ marginLeft: isMobile ? '4%' : '2%', lineHeight: 1.2 }} className="header">
        {(currentPath === '/productBookingf' || currentPath === '/saleorderdetails' || currentPath === '/productBookingg') &&
        orderNumberString !== '0' && orderNumberString != null ? (
          <div style={{ textAlign: 'center' }}>
            <span>{'Order Number' + ' : ' + orderNumberString}</span>
          </div>
        ) : null}

        {showSecondaryOrderDetails ? (
          <div style={{ textAlign: 'center' }}>
            <span>{user?.userName || ''}</span>
            <br />
            <span>{confvalue?.label || ''}</span>
            <br />
            <span style={{ fontSize: '13px' }}>
              Party: {secondaryOrder?.partyName || '-'}{secondaryOrder?.partyCode ? ` (${secondaryOrder.partyCode})` : ''}
              {' | '}Retailer: {secondaryOrder?.retailerName || '-'}
            </span>
          </div>
        ) : currentPath !== '/dashboard' && currentPath !== '/salesorder' && currentPath !== '/myordersreport' ? (
          <div style={{ textAlign: 'center' }}>
            <span style={{ marginRight: '10px' }}>{customer?.partyName}</span>
            <span>{user?.userName || ''}</span>
            <br />
            <span style={{ marginRight: '10px' }}>{distibutor == 'undefined' || distibutor == null ? '' : distibutor}</span>
            <span>{confvalue?.label || ''}</span>
          </div>
        ) : (
          <div style={{ textAlign: 'center' }}>
            <span>{user?.userName || ''}</span>
            <br />
            <span>{confvalue?.label || ''}</span>
          </div>
        )}
      </div>

      <HeaderContent />
    </Toolbar>
  );

  // app-bar params
  const appBar = {
    position: 'fixed',
    color: 'inherit',
    elevation: 0,
    sx: {
      borderBottom: 'none',
      backgroundColor: backgroundColor,
      minHeight: HEADER_HEIGHT + (hasAnnouncement ? MARQUEE_HEIGHT : 0),
      width: hideOnPendingOrder || isMobileSidebar ? '100%' : `calc(100% - ${sidebarWidth}px)`,
      ml: hideOnPendingOrder || isMobileSidebar ? 0 : `${sidebarWidth}px`
      // boxShadow: theme.customShadows.z1
    }
  };

  return (
    <>
      <AppBar {...appBar}>
        {mainHeader}
        {hasAnnouncement ? (
          <div className="header-marquee-bar">
            <div className="header-marquee-track">
              <span>{marqueeText}</span>
            </div>
          </div>
        ) : null}
      </AppBar>
    </>
  );
};

export default Header;
